import m from "../../../../geodata/es2015/region/usa/sdLow";
window.am4geodata_region_usa_sdLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/sdLow.js
// module id = null
// module chunks = 